import { useState } from "react"
import SweetAlert from 'react-bootstrap-sweetalert';
import redirectURL from "../redirectURL";
import { getLandingPage } from "../common/utils";

const ChangePassword = () => {

    const [loader, setLoader] = useState(false)
    const [show, setShow] = useState(false)
    const [title, setTitle] = useState('')
    const [type, setType] = useState('default')
    const [showp1, setShowp1] = useState(false)
    const [showp2, setShowp2] = useState(false)
    const [showp3, setShowp3] = useState(false)
    const [openPasswordModel, setOpenPasswordModel] = useState(false)
    const [oldPassword, setOldPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [rePassword, setRePassword] = useState('')


    const decipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded => encoded.match(/.{1,2}/g)
            .map(hex => parseInt(hex, 16))
            .map(applySaltToChar)
            .map(charCode => String.fromCharCode(charCode))
            .join('');
    }
    var decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
    let user = decode(localStorage.getItem("k"));
    let user_data = JSON.parse(user)//tmsssssssssssssssssssssss
    // let user_data = {
    //     email: ''
    // }

    const cipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const byteHex = n => ("0" + Number(n).toString(16)).substr(-2);
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);

        return text => text.split('')
            .map(textToChars)
            .map(applySaltToChar)
            .map(byteHex)
            .join('');
    }
    var encode = cipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
    const onConfirm = () => {
        setShow(false);
        setLoader(false)
        if(type==="success"){
            window.location.href = getLandingPage(user_data.role);
        }
    };

    const changePassword = async (e) => {
        e.preventDefault()
        var userName = localStorage.getItem("username") || ""
        // Legrand Brands Names
        const brandNames = [
            "Cablofil", "Raritan", "Server Technology", "Starline", "Minkels", "Zucchini",
            "Adorne", "IME", "imesys", "Legrand Arteor", "Legrand electrical distribution box",
            "Living Now", "On Q", "Vantage", "Nuvo", "Legrand", "Indoasian", "Valrack", "Numeric", "Adlec", "Netrack"
        ];
        if (userName && userName.length > 0) {
            var userName = decode(userName)
            brandNames.push(userName) // Ensuring Full Name is not used 
            brandNames.push(userName.slice(0, 5)) // Ensuring first 5 digits are not used 
            brandNames.push(userName.slice(-5))  // Ensuring last 5 digits are not used 
        }
        // console.log(brandNames)
        // Function to normalize the brand name or password by removing special characters and converting to lowercase
        function normalizeText(text) {
            return text.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        }
        const normalizedPassword = normalizeText(newPassword);
        for (let brand of brandNames) {
            if (normalizedPassword.includes(normalizeText(brand))) {
                setShow(true);
                setTitle("The password should not include Legrand brand names or User Name");
                setType("danger");
                return false;
            }
        }
        if (newPassword !== rePassword) {
            setShow(true)
            setTitle("Password's does not match")
            setType("danger")
        }
        else if (oldPassword == newPassword) {
            setShow(true)
            setTitle("Old and New Passwords must be different")
            setType("danger")
        }
        else if (!validatePassword(newPassword)) {
            setShow(true);
            setTitle(passWordChangeTitle);
            setType("danger");
        }
        else {
            setLoader(true)
            
            let body = {
                r: encode(oldPassword),
                f: encode(newPassword),
                u: encode(user_data.email)
            }
             var isNewUser = localStorage.getItem("is_new_user") || 0
            if(isNewUser==1){
                body.isNewUser = 1
            }
            
            await redirectURL.post("/updatePassword", body)            
                .then(response => {
                    if (response.data.status == "success") {
                        localStorage.removeItem("password_updated_on");  // Removes the "password_updated_on" entry from localStorage
                      
                        setLoader(false)
                        setShow(true)
                        setTitle(response.data.message)
                        setType("success")
                        setOpenPasswordModel(false)
                        setOldPassword('')
                        setNewPassword('')
                        setRePassword('')
                        if(isNewUser==1){
                            localStorage.removeItem("is_new_user")
                        }                        
                    }
                    else {
                        setLoader(false)
                        setShow(true)
                        setTitle(response.data.message)
                        setType("danger")
                    }
                })
                .catch(err => console.log(err))
        }
        setLoader(false)
    }
    const validatePassword = (password) => {
        // Updated password regex (no min/max length restrictions)
        const passwordRegex = new RegExp(
            "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^&*()_+~`|}{[\\]:;?><,./])"
        );
        if (password.length < minLength || password.length > maxLength) {
            return false;
        }
        return passwordRegex.test(password);
    };
    // Get the necessary values from localStorage
    const isAdmin = localStorage.getItem("is_admin") === "admin";  // directly check if "is_admin" is "admin"
    const passwordUpdatedOn = localStorage.getItem("password_updated_on") || "";
    const isPassWordReset = localStorage.getItem("is_new_user") || 0
    // Set default password length and title
    let minLength = 12;
    let maxLength = 16;
    let passWordChangeTitle = "Password must contain at least 1 lowercase letter, 1 uppercase letter, 1 number, 1 special character, and be between 12 and 16 characters long";
    // Adjust password length and title for admin
    if (isAdmin) {
        minLength = 16;
        maxLength = 20;
        passWordChangeTitle = "Password must contain at least 1 lowercase letter, 1 uppercase letter, 1 number, 1 special character, and be between 16 and 20 characters long";
    }
    // console.log(minLength, maxLength, "lengths");
    // Calculate password age
    const differenceInDays = calculateDateDifference(passwordUpdatedOn);
    const updatedDays = parseInt(differenceInDays, 10) || 0;
    // Check if password is expired based on the user type
    let isPasswordExpired = false;
    if ((isAdmin && updatedDays >= 180) || (!isAdmin && updatedDays >= 365) || (isPassWordReset==1)) {
        isPasswordExpired = true;
    }
    return (
        <div className="card">
            <SweetAlert
                show={show}
                title={<span style={{ fontSize: "1rem" }}>{title}</span>}
                onConfirm={onConfirm}
                confirmBtnBsStyle={type}
                confirmBtnCssClass="sweetButton"
                customClass='sweetWidth'
                type={type}>
            </SweetAlert>
            <div className="col-6" style={{ marginInline: "2rem", marginBlock: "2rem", border: "2px solid #cccc", borderRadius: "12px" }}>
                <div className="pl-3 pt-3">

                </div>
                <div className="pl-3 pt-3">
                    <div className="flex-left-center">
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "50px", height: "50px", backgroundColor: "#84D2F6", borderRadius: "50%" }}><i className="fa fa-lock" style={{ color: "#ffff" }} /></div>
                        <div style={{ fontSize: "22px", fontWeight: "700" }}>&nbsp;&nbsp;&nbsp;Change Password</div>
                    </div>
                    <p className="mt-2">
                        To change your password, your new password should contain at least one lowercase letter, one uppercase letter, one number, and one special character.
                        {isAdmin ? (
                            <> It must be between 16 to 20 characters long.</>
                        ) : (
                            <> It must be between 12 to 16 characters long.</>
                        )}
                    </p>
                    {isPasswordExpired && (
                        <p style={{ color: "red" }}>
                            Your password is expired. Please reset the password.
                        </p>
                    )}
                    <form className="" onSubmit={changePassword}>
                        <div className="m-4 text-center">
                            <div className="col-xl-12 col-lg-12">
                                <div style={{ display: "flex" }}>
                                    <label style={{ color: "#EB1D54", fontSize: "16px" }}>*&nbsp;</label>
                                    <label className="custom-label" style={{ fontSize: "13px" }}>
                                        Old Password
                                    </label>
                                </div>
                                <div className="password-input-wrapper">
                                    <input
                                        className="form-control"
                                        type={(showp1) ? "text" : "password"}
                                        placeholder="Old Password"
                                        name='oldPassword'
                                        value={oldPassword}
                                        onChange={(e) => setOldPassword(e.target.value)}
                                        required />
                                    {
                                        showp1 ?
                                            <i className="fa fa-eye eye-icon2" onClick={() => setShowp1(prev => !prev)} /> :
                                            <i className="fa fa-eye-slash eye-icon2" style={showp1 ? { top: "60%" } : {}} onClick={() => setShowp1(prev => !prev)} />
                                    }
                                </div>
                            </div>
                            <br />
                            <div className="col-xl-12 col-lg-12">
                                <div style={{ display: "flex" }}>
                                    <label style={{ color: "#EB1D54", fontSize: "16px" }}>*&nbsp;</label>
                                    <label className="custom-label" style={{ fontSize: "13px" }}>
                                        New Password
                                    </label>
                                </div>
                                <div className="password-input-wrapper">
                                    <input
                                        className="form-control"
                                        type={(showp2) ? "text" : "password"}
                                        placeholder="New Password"
                                        name='newPassword'
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        // pattern={`^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z])}$`} // Validating Pattern is not working as expected 
                                        title={passWordChangeTitle}
                                        minLength={minLength}
                                        maxLength={maxLength}
                                        required />
                                    {
                                        showp2 ?
                                            <i className="fa fa-eye eye-icon2" onClick={() => setShowp2(prev => !prev)} /> :
                                            <i className="fa fa-eye-slash eye-icon2" style={showp2 ? { top: "60%" } : {}} onClick={() => setShowp2(prev => !prev)} />
                                    }
                                </div>
                            </div>
                            <br />
                            <div className="col-xl-12 col-lg-12">
                                <div style={{ display: "flex" }}>
                                    <label style={{ color: "#EB1D54", fontSize: "16px" }}>*&nbsp;</label>
                                    <label className="custom-label" style={{ fontSize: "13px" }}>
                                        Re-Enter New Password
                                    </label>
                                </div>
                                <div className="password-input-wrapper">
                                    <input
                                        className="form-control"
                                        type={(showp3) ? "text" : "password"}
                                        placeholder="Confirm Password"
                                        name='reNewPassword'
                                        value={rePassword}
                                        // pattern={`^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z])}$`} // Validating Pattern is not working as expected 
                                        title={passWordChangeTitle}
                                        minLength={minLength}
                                        maxLength={maxLength}
                                        onChange={(e) => setRePassword(e.target.value)}
                                        required />
                                    {
                                        showp3 ?
                                            <i className="fa fa-eye eye-icon2" onClick={() => setShowp3(prev => !prev)} /> :
                                            <i className="fa fa-eye-slash eye-icon2" style={showp3 ? { top: "60%" } : {}} onClick={() => setShowp3(prev => !prev)} />
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="m-3" style={{ display: "flex", justifyContent: "flex-end" }}>
                            <button type='submit' className='config-button btn' style={{ background: "#a064ba", color: "#ffff" }}>Apply</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
export default ChangePassword

function calculateDateDifference(date1 = "",) {
    // Convert the date strings to Date objects
    const dateObj1 = new Date(date1);
    const dateObj2 = new Date();
    // Calculate the difference in milliseconds
    const diffInMilliseconds = Math.abs(dateObj2 - dateObj1);
    // Convert milliseconds to days (1 day = 24 hours * 60 minutes * 60 seconds * 1000 milliseconds)
    const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);
  
    return diffInDays;
  }